import {createApp} from 'vue'
import App from './App.vue'
import {createI18n} from 'vue-i18n'
import messages from '@intlify/vite-plugin-vue-i18n/messages'
import VueSmoothScroll from 'vue3-smooth-scroll'

import VueAxios from 'vue-axios'
import axios from 'axios'
import {store} from "@/components/store";

import * as Sentry from "@sentry/vue";


const i18n = createI18n({
    legacy: false,
    locale: import.meta.env.VITE_LANGUAGE, // NOTE: nastavení jazyku formuláře
    messages
})



const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://75c5d7a7231c12901cbb9a68b615fa8c@o4508263390052352.ingest.de.sentry.io/4508263391887440",
    // SDK chytá i globální chyby celé stránky webu (Nette, inline onclick), hlásit jen chyby z bundlu formu
    allowUrls: [/\/plugins\/jakeSeatOrderForm\//],
    beforeSend(event) {
        if (event.exception) {
            const stacktrace = event.exception.values[0]?.stacktrace;
            if (stacktrace && stacktrace.frames) {
                // Ignoruj chyby z Cookiebot nebo jiných specifických knihoven
                const isExternalError = stacktrace.frames.some(frame =>
                    frame.filename.includes('cookiebot.com') //||
                    //frame.filename.includes('@sentry/browser')
                );
                if (isExternalError) {
                    return null; // Zahoď událost
                }
            }
        }
        return event; // Pošli ostatní chyby
    },
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    enabled: process.env.NODE_ENV !== 'development',
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay: Free plán má 50 replays měsíčně, nahrávat jen session s chybou
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
});

app.use(i18n)
app.use(VueAxios, axios)
app.use(VueSmoothScroll, {
    offset: -120,

})
app.mount('#appJakeSeatForm')


// errory z vue apky budou mít tag vue-error = true
app.config.errorHandler = (err,vm,info) => {
    Sentry.withScope(function (scope) {
        scope.setTag("vue-error", "true");
        scope.setExtra("info", info);
        Sentry.captureException(err);
    });
}


// Propojení s komponentou HQ list.
window.prepnoutAdresu = function (code) {
    scrollToForm();
    // Dispatch a custom event with the id as detail.
    const event = new CustomEvent('prepnout-adresu', {detail: code});
    window.dispatchEvent(event);
}

//Scroll k formuláři po výběru sídla z HQ listu
window.scrollToForm = function () {
    const element = document.getElementById('appJakeSeatForm');
    if (element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let offset = 130;
        if (window.innerWidth < 992)
            offset = -200;


        // Skrolujte na formulář.
        window.scrollTo({
            top: rect.top + scrollTop - offset,
            behavior: 'smooth'
        });
    }
}

window.nastavPoradi = function (seats) {
    console.log(seats[0]);
    console.log("Pořadí", seats);

    //code u praha 5 se liší
    seats.filter(s=>{
        if(s.code === 'UK03')
            s.code = 'SP05_12'
    })

    const orderMap = seats.reduce((acc, el, index) => {
      acc[el.code] = index;
      return acc;
    }, {});
    store.form.seatsProducts.sort((a, b) => orderMap[a.code] - orderMap[b.code]);

}